<template>
  <div class="row">
    <div class="col-sm-12 text-end">
      Not a client? <a href="#" @click="notClient">Click here</a>
    </div>
  </div>

  <div class="pt-4 pb-2">
    <h5 class="card-title text-center pb-0 fs-4">Log in</h5>
  </div>

  <div>
    <form class="row g-3 needs-validation" novalidate>
      <div class="col-12">
        <label for="yourUsername" class="form-label">Username</label>

        <input type="text" name="username" v-model="usuario" class="form-control" id="yourUsername" required>
        <div class="invalid-feedback">Please enter your username.</div>

      </div>

      <div class="col-12">
        <label for="yourPassword" class="form-label">Password</label>
        <input type="password" name="password" v-model="clave" class="form-control" id="yourPassword" required>
        <div class="invalid-feedback">Please enter your password!</div>
      </div>

      <div class="col-12 mt-5">
        <button class="btn btn-primary w-100" type="button" @click="login">Log in</button>
      </div>

      <br/>
      <a href="#" data-bs-toggle="modal" data-bs-target="#mdlForgotPassword">Forgot your password?</a>
    </form>
  </div>
</template>

<script>

export default {
  name: 'login-page',
  data: function () {
    return {
      usuario: "",
      clave: ""
    }
  },
  components: {
    
  },
  methods: {
    login() {
      let usr = { Username: this.usuario, Password: this.clave };
      let self = this;
      this.$vtc.vtcFetch("/Auth/Login", usr,'API2').then(function (r) {

        if (r === false) {
          alert("Error, wrong username or password");
        }
        else {
          let usr = r;
          usr.isAdmin = (usr.rol?.includes("admin") || usr.rol?.includes("consultant")) //duplicado en getUserloggeado?

          let tk = usr.token;
          self.$vtc.setUserToken(tk)
          self.$vtc.setUsuarioLogueado(usr)
          self.$vtc.setNameLogueado(usr.name);

          console.log("logeado",self.$vtc.getUsuarioLogueado());
          self.$emit('logged', usr)
        }
      });
    },
    notClient(){
      this.$emit('notclient')
    }
  }
}
</script>
